import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Navigation } from '@ucheba/ui/components/Navigation/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { updateSticky } from '@ucheba/ui/components/Sticky'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { InstitutionsList } from '../../../../../../components/InstitutionsList/desktop'
import { IWhereAreStudyingProps } from '../types'
import { useWhereAreStudying } from '../bll'

const Block = styled.div``

/** Где учиться на {профессия} */
const WhereAreStudying: FC<IWhereAreStudyingProps> = (props) => {
  const { items, title, tagsId, specialityIds } = props
  const isAuth = useSelector(authSelectors.isAuth)
  const {
    href,
    buttonText,
    navItems,
    activeIndex,
    handleClick,
    activeProgramType,
    total,
  } = useWhereAreStudying(props)

  return (
    <Block>
      <Heading h2={title} spacing='small' />

      {navItems && navItems.length > 0 && (
        <>
          <Navigation items={navItems} activeIndex={activeIndex} onClick={handleClick} />

          <Spacing spacing='xlarge' />
        </>
      )}

      {total > 0 && (
        <LimitedList
          items={items}
          limit={5}
          total={total}
          onShowAll={updateSticky}
          buttonText={buttonText}
          id='institutions'
          isAuth={isAuth}
          redirect={href}
          showAllButtonLinkIsLink={false}
        >
          {({ limitedItems }) => (
            <InstitutionsList
              items={limitedItems}
              tagId={tagsId || undefined}
              specialityIds={specialityIds}
              activeProgramType={activeProgramType}
            />
          )}
        </LimitedList>
      )}
    </Block>
  )
}

export default memo(WhereAreStudying)
